import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=56e71e84&"
import script from "./SuppliersList.vue?vue&type=script&lang=js&"
export * from "./SuppliersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e71e84')) {
      api.createRecord('56e71e84', component.options)
    } else {
      api.reload('56e71e84', component.options)
    }
    module.hot.accept("./SuppliersList.vue?vue&type=template&id=56e71e84&", function () {
      api.rerender('56e71e84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/SuppliersList.vue"
export default component.exports